import { render } from "./GigaVue.vue?vue&type=template&id=5939def0"
import script from "./GigaVue.vue?vue&type=script&lang=js"
export * from "./GigaVue.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./GigaVue.vue?vue&type=style&index=0&id=5939def0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script